import React, { useEffect, useState } from 'react'
import { Modal, Table, Descriptions, Spin, Alert, Row, Col } from 'antd'
import apiRequest from '../hooks/ApiRequest'
import moment from 'moment'

const TransactionHistoryModal = ({ visible, onCancel, policyNumber }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!policyNumber || !visible) return

    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        const res = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicyPaymentStatus/get-policy-payment-status/${policyNumber}`,
          'GET'
        )
        if (res.success && res.data) {
          setData(res.data)
        } else {
          setError('Failed to fetch transaction history.')
        }
      } catch (err) {
        console.error(err)
        setError('Something went wrong while fetching data.')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [policyNumber, visible])

  const columns = [
    {
      title: 'Transaction ID',
      dataIndex: 'transactionId',
      key: 'transactionId',
    },
    {
      title: 'Premium Paid',
      dataIndex: 'premiumPaid',
      key: 'premiumPaid',
      render: val => `${parseFloat(val).toFixed(2)}`,
    },
    {
      title: 'Payment Date',
      dataIndex: 'paymentDate',
      key: 'paymentDate',
      render: val => moment(val).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: 'Payment Mode',
      dataIndex: 'paymentMode',
      key: 'paymentMode',
    },
  ]

  return (
    <Modal
      visible={visible}
      title={`Transaction History - ${policyNumber}`}
      onCancel={onCancel}
      footer={null}
      width={800}
      destroyOnClose
    >
      {loading ? (
        <Spin />
      ) : error ? (
        <Alert message={error} type="error" />
      ) : data ? (
        <>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Descriptions size="small" bordered column={1}>
                <Descriptions.Item label="Policy Number:">{data.policyNumber}</Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" bordered column={1}>
                <Descriptions.Item label="Total Premium:">{data.grandTotalTermPremium.toFixed(2)}</Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" bordered column={1}>
                <Descriptions.Item label="Total Paid:">{data.totalPaid.toFixed(2)}</Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" bordered column={1}>
                <Descriptions.Item label="Pending Amount:">{data.pendingAmount.toFixed(2)}</Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={12}>
              <Descriptions size="small" bordered column={1}>
                <Descriptions.Item label="Fully Paid:">{data.isFullyPaid ? 'Yes' : 'No'}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>


          <Table
            dataSource={data.transactions}
            columns={columns}
            rowKey="transactionId"
            style={{ marginTop: 24 }}
            pagination={false}
          />
        </>
      ) : (
        <Alert message="No data found." type="info" />
      )}
    </Modal>
  )
}

export default TransactionHistoryModal
